<template>
  <div
    class="flex-grow-1 editor-container align-self-baseline"
    :class="{
      'errored-field': errors,
      'editor-shown': showEditor
    }"
  >
    <div
      class="text-secondary editor-placeholder"
      v-if="!showEditor"
      role="button"
      @click="loadEditor"
    >
      Add a comment
    </div>
    <div class="editor-wrapper">
      <ck-editor
        class="comment-editor"
        v-if="showEditor && usersInScope.length > 0"
        :config="ckeditorConfig(goal)"
        :initial-data="getEditorData()"
        :id="editorId"
        @save="onSave"
        @change="$emit('change', $event)"
      />
      <template v-if="errors">
        <div class="field-error-message" v-for="error in errors" :key="error">
          {{ error }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { getCKEditorConfig } from '@/ckeditorConfig'
import CkEditor from '@/components/CkEditor'
import MembershipsMixin from '@/mixins/MembershipsMixin'
import PersistentEditorMixin from '@/mixins/PersistentEditorMixin'

/**
 * This provides an editor to type checkin comment.
 * props:
 * - errors: errors to be shown in editor
 * - krId
 * @emits:
 * - change
 * - save
 */
export default {
  name: 'BulkCheckinEditor',
  props: ['errors', 'krId'],
  components: {
    CkEditor
  },
  mixins: [MembershipsMixin, PersistentEditorMixin],
  data() {
    return {
      showEditor: false, // this data property is being used by BulkCheckin.vue too
      editorId: 'editor-' + this.krId
    }
  },
  computed: {
    kr() {
      return this.$store.getters.keyResultById(this.krId)
    },
    goal() {
      return this.$store.getters.goalById(this.kr.goalId)
    },
    usersInScope() {
      return this.getUsersInScope(this.goal.teamId, this.goal.organizationId)
    }
  },
  methods: {
    ckeditorConfig() {
      return getCKEditorConfig({
        startupFocus: true,
        height: 90,
        maxHeight: 200,
        users: this.usersInScope,
        orgId: this.kr.organizationId
      })
    },
    loadEditor() {
      this.showEditor = true
    },
    onSave() {
      this.$emit('save')
      this.clearEditorStoredData()
    }
  },
  mounted() {
    this.initializeEditorPersistence({ editorId: this.editorId })
    if (this.getEditorData()) {
      this.loadEditor()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';
@import '~@/styles/_errors.scss';

.editor-container {
  padding: 6px 10px;
  border: 1px solid $borderPrimary;
  border-radius: 10px;
  margin-top: -2px;
}
.editor-container.editor-shown {
  min-height: 141px;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
